import { isBefore } from 'date-fns';

const handleAfterTicketSoldOutScheduled = ({ entity, entityKey, allEntities, checkSoldOut, now }) => {
  if (!entity[entityKey]) {
    return { isScheduled: false, hasInvalidReference: false };
  }

  const referencedEntity = allEntities.find(e => e._id === entity[entityKey]);
  if (!referencedEntity) {
    return { isScheduled: false, hasInvalidReference: true };
  }

  if (referencedEntity.status !== 'enabled') {
    return { isScheduled: false, hasInvalidReference: true };
  }

  // Check if our own sale window has ended
  const ourSaleEndOn = entity.saleEndOn ? new Date(entity.saleEndOn) : null;

  if (ourSaleEndOn == null) {
    return { isScheduled: !checkSoldOut(referencedEntity), hasInvalidReference: false };
  }

  const isBeforeOurEnd = isBefore(now, ourSaleEndOn);

  return {
    isScheduled: !checkSoldOut(referencedEntity) && isBeforeOurEnd,
    hasInvalidReference: false,
  };
};

export default handleAfterTicketSoldOutScheduled;